import { render, staticRenderFns } from "./ImageProperties.vue?vue&type=template&id=6d5ff196&scoped=true&lang=pug"
import script from "./ImageProperties.vue?vue&type=script&lang=js"
export * from "./ImageProperties.vue?vue&type=script&lang=js"
import style0 from "./ImageProperties.vue?vue&type=style&index=0&id=6d5ff196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ff196",
  null
  
)

export default component.exports